import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//

/* eslint-disable */
// 接口api
import { getAllListFn } from 'api/org/position';
export default {
  model: {
    prop: ['value']
  },
  props: {
    value: Number | String,
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      options: [],
      selectValue: ''
    };
  },
  created: function created() {
    var _this = this;
    getAllListFn().then(function (res) {
      _this.options = res.data;
    });
  },
  methods: {
    change: function change(v) {
      this.$emit('input', v);
    }
  }
};